import { Component, ViewChild, ViewContainerRef, HostBinding, Input, TemplateRef } from "@angular/core";
import { SuiComponentFactory } from "../../../misc/util/index";
// See https://github.com/Microsoft/TypeScript/issues/13449.
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '../../../misc/util/index';
import * as ɵngcc2 from '@angular/common';

var _c0 = ["templateSibling"];
function SuiSearchResult_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 2);
} if (rf & 2) {
    var ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.formatter(ctx_r1.value, ctx_r1.query), ɵngcc0.ɵɵsanitizeHtml);
} }
var templateRef = TemplateRef;
var SuiSearchResult = /** @class */ (function () {
    function SuiSearchResult(componentFactory) {
        this.componentFactory = componentFactory;
        this._optionClasses = true;
        // By default we make this function return an empty string, for the brief moment when it isn't displaying the correct label.
        this.formatter = function (value) { return ""; };
    }
    Object.defineProperty(SuiSearchResult.prototype, "template", {
        get: function () {
            return this._template;
        },
        set: function (template) {
            this._template = template;
            if (this.template) {
                this.componentFactory.createView(this.templateSibling, this.template, {
                    $implicit: this.value,
                    query: this.query
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    /** @nocollapse */
    SuiSearchResult.ctorParameters = function () { return [
        { type: SuiComponentFactory, },
    ]; };
    SuiSearchResult.propDecorators = {
        "_optionClasses": [{ type: HostBinding, args: ["class.result",] },],
        "value": [{ type: Input },],
        "query": [{ type: Input },],
        "formatter": [{ type: Input },],
        "template": [{ type: Input },],
        "templateSibling": [{ type: ViewChild, args: ["templateSibling", { read: ViewContainerRef },] },],
    };
SuiSearchResult.ɵfac = function SuiSearchResult_Factory(t) { return new (t || SuiSearchResult)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.SuiComponentFactory)); };
SuiSearchResult.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SuiSearchResult, selectors: [["sui-search-result"]], viewQuery: function SuiSearchResult_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateSibling = _t.first);
    } }, hostVars: 2, hostBindings: function SuiSearchResult_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("result", ctx._optionClasses);
    } }, inputs: { formatter: "formatter", template: "template", value: "value", query: "query" }, decls: 3, vars: 1, consts: [["templateSibling", ""], [3, "innerHTML", 4, "ngIf"], [3, "innerHTML"]], template: function SuiSearchResult_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "span", null, 0);
        ɵngcc0.ɵɵtemplate(2, SuiSearchResult_span_2_Template, 1, 1, "span", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.template);
    } }, directives: [ɵngcc2.NgIf], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SuiSearchResult, [{
        type: Component,
        args: [{
                selector: "sui-search-result",
                template: "\n<span #templateSibling></span>\n<span *ngIf=\"!template\" [innerHTML]=\"formatter(value, query)\"></span>\n"
            }]
    }], function () { return [{ type: ɵngcc1.SuiComponentFactory }]; }, { _optionClasses: [{
            type: HostBinding,
            args: ["class.result"]
        }], formatter: [{
            type: Input
        }], template: [{
            type: Input
        }], value: [{
            type: Input
        }], query: [{
            type: Input
        }], templateSibling: [{
            type: ViewChild,
            args: ["templateSibling", { read: ViewContainerRef }]
        }] }); })();
    return SuiSearchResult;
}());
export { SuiSearchResult };

